module.exports = __webpack_public_path__ + "static/media/steren2.7a424520.png";